import React, { useState } from 'react';
import {
  Dialog,
  DialogContent,
  Typography,
  IconButton,
  Box
} from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { DataGridPro } from '@mui/x-data-grid-pro';
import DownloadIcon from '@mui/icons-material/Download';
import VisibilityIcon from '@mui/icons-material/Visibility';
import CloseIcon from '@mui/icons-material/Close';
import { convertESTToLocal } from 'components/formatDate';
import { formatUSCurrency } from 'components/CurrencyFormat';
import SubscriptionPaymentReceipt from './SubscriptionPaymentReceipt';

const InvoiceHistoryDialog = ({ open, onClose, invoices = [], openReceipt, handleCloseReceipt, handleOpenReceipt, historyLoading }) => {
  const [paginationModel, setPaginationModel] = React.useState({
    pageSize: 10,
    page: 0
  });

  const showAllValue = invoices.length;
  const [payment, setPayment] = useState({});

  const columns = [
    {
      field: 'id',
      headerName: 'Payment ID',
      width: 120,  
      renderCell: (params) => params.value
    },
    {
      field: 'createdBy',
      headerName: 'Paid By',
      width: 130,  
      renderCell: (params) => (
        <div style={{ display: 'flex', alignItems: 'center' }}>          
          {params.value}
        </div>
      )
    },
    { 
      field: 'createDate', 
      headerName: 'Date', 
      width: 120,  // Reduced from 120
      renderCell: (params) => convertESTToLocal(params.value)
    },
    {
      field: 'amount',
      headerName: 'Amount',
      width: 120,  // Reduced from 120
      renderCell: (params) => formatUSCurrency(params.value)
    },         
    {
      field: 'status',
      headerName: 'Status',
      width: 120,  
      renderCell: (params) => (        
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <div
            style={{
              width: 8,
              height: 8,
              borderRadius: '50%',
              backgroundColor: 
                params.value === 'Pending'
                  ? '#FFC107'
                  : params.value === 'Completed'
                  ? '#4CAF50'
                  : params.value === 'Failed'
                  ? '#F44336'
                  : '#BDBDBD',
              marginRight: 8
            }}
          />
          {params.value === 'Completed'? 'Paid' : params.value}
        </div>
      )
    },   
    {
      field: 'actions',
      headerName: 'Actions',
      width: 100,  
      renderCell: (params) => (
        <div>
          <IconButton size="small" aria-label="preview" onClick={() => { handleReceiptOpen(params.row) }}>
            <VisibilityIcon fontSize="small" />
          </IconButton>
          <IconButton size="small" aria-label="download">
            <DownloadIcon fontSize="small" />
          </IconButton>
        </div>
      )
    }
  ];

  const handleReceiptOpen = (row) => {
    setPayment(row);
    handleOpenReceipt();
  }

  return (    
    <>
      <Dialog 
        open={open} 
        onClose={onClose} 
        maxWidth="sm"  
        fullWidth={false}  
        PaperProps={{
          sx: {
            height: '70vh',
            maxHeight: 800,
            width: '90%',  // Further control width
            maxWidth: 800   // Absolute maximum width
          }
        }}
      >
        <DialogContent sx={{ 
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          p: 2,  // Reduced padding from 3 to 2
          overflow: 'hidden'
        }}>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              mb: 2  // Reduced margin from 3 to 2
            }}
          >
            <div>
              <Typography variant="h4">  
                Payment History
              </Typography>
              <Typography variant="body1" color="textSecondary">  
                View and download past payments
              </Typography>
            </div>
            <IconButton
              onClick={onClose}
              sx={{ position: 'absolute', right: 8, top: 8 }}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
          </Box>

          <Box sx={{ 
            flex: 1,
            width: '100%',
            overflow: 'hidden',
            '& .MuiDataGrid-virtualScroller': {
              overflowY: 'auto',
              overflowX: 'auto'
            }
          }}>
          <DataGridPro
            rows={invoices}
            columns={columns}
            loading={historyLoading}
            // pagination
            // paginationModel={paginationModel}
            // onPaginationModelChange={setPaginationModel}
            // pageSizeOptions={[10, 50, { value: showAllValue, label: 'Show All' }]}
            disableRowSelectionOnClick
            slots={{
              footer: () => null
            }}
            disableColumnResize={false}   // allow resizing
            autoHeight={false}            // prevent auto expansion
            sx={{
              width: "100%",
              height: "100%",
              overflowX: "auto", // enable horizontal scroll
              '& .MuiDataGrid-columnHeaders': {
                minWidth: 'max-content',  // force headers to expand
              },
              '& .MuiDataGrid-virtualScrollerContent': {
                minWidth: 'max-content',  // force rows to expand
                minHeight: '150px !important',
              },
              '& .MuiDataGrid-columnHeaderTitle': {
                fontSize: '0.75rem',
                textTransform: 'none',
                fontWeight: 'normal'
              },
              '& .MuiDataGrid-cell': {
                fontSize: '0.75rem',
                fontWeight: 'normal'
              }
            }}
          />
          </Box>
        </DialogContent>
      </Dialog>
      
      <SubscriptionPaymentReceipt
        open={openReceipt}
        handleClose={handleCloseReceipt}
        PaymentData={payment}
      />
    </>
  );
};

export default InvoiceHistoryDialog;